export function normalizeDomain(domain) {
    let match = domain.match(/^(https?:\/\/[^\/]+)\/.+/);

    return match ? match[1] : domain;
}
